module.exports = "<toast></toast><div class=\"public\"><div class=\"container\"><ui-view></ui-view></div></div>";